import { z } from 'zod'
import { AccountStatusIdSchema } from '../ids'
import { CustomFieldIdSchema } from '../customField/id'

const ACCOUNT_TABLE_COLUMN_IDS = [
  'resident.name',
  'resident.email',
  'resident.phone',
  'location',
  'owner',
  'closer',
  'status',
  'daysSinceLastAction',
  'lastActionDate',
  'createdAt',
  'updatedAt',
  'appointmentDate',
  'accountSource',
  'sourceStatus',
  'sourceId',
  'externalLeadId',
  'importId',
  'accountId',
  'team',
] as const

export const AccountTableColumnSchema = z.enum(ACCOUNT_TABLE_COLUMN_IDS)
export const AccountTableColumnIdSchema = z.union([
  AccountTableColumnSchema,
  AccountStatusIdSchema,
  CustomFieldIdSchema,
])
export type AccountTableColumnId = z.infer<typeof AccountTableColumnIdSchema>
export const isAccountTableColumnId = (columnId: unknown): columnId is AccountTableColumnId =>
  AccountTableColumnIdSchema.safeParse(columnId).success

// Table columns whose sort maps to an account list query sort
export const AccountTableSortColumnIdSchema = z.union([
  z.enum(['createdAt', 'daysSinceLastAction', 'lastActionDate']),
  CustomFieldIdSchema,
])
export type AccountTableSortColumnId = z.infer<typeof AccountTableSortColumnIdSchema>
